import React from 'react';
import styles from './SettingChips.module.css';

export default function SettingChips({ options, value, onChange, ariaLabel }) {
	return (
		<div className={styles.chips} role="radiogroup" aria-label={ariaLabel}>
			{options.map((option) => {
				const id = typeof option === 'object' ? option.id : option;
				const label = typeof option === 'object' ? option.label : String(option);
				const isActive = value === id;

				return (
					<button
						key={id}
						type="button"
						className={`${styles.chip} ${isActive ? styles.chipActive : ''}`}
						role="radio"
						aria-checked={isActive}
						onClick={() => onChange(id)}
					>
						{label}
					</button>
				);
			})}
		</div>
	);
}
